import React, { useRef, useState } from 'react'
import { galleryResource } from '../types/galleryResource'
import { useInfo } from '../context/useInfo';

interface VaultFileUploadProps {
    uploadCallback?: (resource: {
        resource: galleryResource,
        size: number
        success: boolean
    }) => void
}

function VaultFileUpload(
    { uploadCallback }: VaultFileUploadProps
) {
    const { fetchWeb } = useInfo();

    const uploadImageRef = useRef<HTMLInputElement>(null);
    const checkboxPublicRef = useRef<HTMLInputElement>(null);

    const [fileName, setFileName] = useState<string>("")
    const [fileLabel, setLabel] = useState<string>("")
    const [blobData, setBlobData] = useState<Blob | null>(null)
    const [fileType, setFileType] = useState<string>("image/jpeg");

    const uploadResource = async () => {
        let publicState = 1;
        if (checkboxPublicRef.current != null) publicState = checkboxPublicRef.current.checked ? 1 : 0;

        const response = await fetchWeb('/gallery/create', {
            method: 'POST',
            headers: {
                'Content-Type': fileType,
                'public': publicState,
                'label': String(fileLabel)
            },
            data: blobData
        }, false)

        if (response) {
            if (response["resource"] && isNaN(parseInt(response.resource["size"])) == false) {
                if (uploadCallback) uploadCallback(response)
            }

            setFileName("")
            setBlobData(null)
        }
    }

    const uploadFile = async () => {
        if (uploadImageRef.current == null) return;
        const files = uploadImageRef.current.files;
        if (files == null || files[0] == null) return;

        if (String(files[0].type).includes("image/gif") || String(files[0].type).includes("video")) {
            setBlobData(files[0])
            setFileName(files[0].name)
            setLabel(files[0].name)
            setFileType(files[0].type)
            return;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
            let image = new Image();
            image.src = reader.result as string;

            image.onload = function () {
                var canvas = document.createElement("canvas");
                const biggestSide = Math.max(image.height, image.width);
                const smallestSide = Math.min(image.height, image.width);

                const resizeFactor = Math.min(512, smallestSide, biggestSide / 1.5);

                if (biggestSide == image.height) {
                    const newSide = resizeFactor / (image.height / image.width); // resizeFactor / height factor
                    canvas.width = newSide;
                    canvas.height = resizeFactor;
                } else {
                    const newSide = resizeFactor / (image.width / image.height); // resizeFactor / width ratio
                    canvas.width = resizeFactor;
                    canvas.height = newSide;
                }
                let ctx = canvas.getContext("2d");
                ctx!.drawImage(image, 0, 0, canvas.width, canvas.height);

                canvas.toBlob(blob => {
                    if (blob == null) return;
                    setFileType("image/webp")
                    setBlobData(blob)
                    setFileName(files[0]!.name)
                }, "image/webp");

                // setPreview(dataURL)
            }
        }
        reader.readAsDataURL(files[0]);
    }

    return <>
        <label
            className={
                'overlapper mt-4 text-[length:2rem] font-medium text-outline p-4 outline-dashed h-[70%] ' +
                'outline-[length:3] outline-outline rounded-md has-[:active]:outline-orange-500 has-[:active]:text-orange-500'
            }
        >
            <div className='-m-4 p-4 rounded-md bg-foreground pointer-events-none flex flex-wrap items-center justify-center gap-4 z-[1]'>
                <img src="/images/document.png" draggable={false} className='h-20' />
                {fileName == "" ? <div className='[&_span]:block flex-grow basis-48'>
                    <span>Drag and drop here</span>
                    <span className='text-base font-normal '>or click to upload</span>
                </div> : <span>{fileName}</span>}
            </div>
            <input className='w-full outline-none cursor-pointer -m-4 text-transparent bg-transparent opacity-0' type="file" ref={uploadImageRef} onChange={() => uploadFile()} />
        </label>
        {blobData != null && (
            <div className='mt-2 flex items-center justify-between '>
                <button className='btn' onClick={() => { setBlobData(null); setFileName("") }}>Clear</button>
                <input className='inp flex-grow' type="text" placeholder="Label" onChange={e => setLabel(e.target.value)} value={fileLabel} />
                <input className='ml-2 hidden' type="checkbox" ref={checkboxPublicRef} />
                <button className='filled-btn' onClick={uploadResource}>Upload</button>
            </div>
        )}
    </>
}

export default VaultFileUpload